import { render, staticRenderFns } from "./UserStakingList.vue?vue&type=template&id=6e879254&scoped=true&"
import script from "./UserStakingList.vue?vue&type=script&lang=js&"
export * from "./UserStakingList.vue?vue&type=script&lang=js&"
import style0 from "./UserStakingList.vue?vue&type=style&index=0&id=6e879254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e879254",
  null
  
)

export default component.exports